import riot from 'riot';
import events from '../src/events.js';
import { getQuestions as libGetQuestions, getAnswers as libGetAnswers, postAnswers as libPostAnswers } from '../src/lib.js';
riot.tag2('knowledge-check', '<div class="container is-fluid has-text-centered" show="{questionsLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <article class="message is-danger is-large" if="{answersError}"> <div class="message-body"> Uh Oh! It looks like there was an error getting your previous answers! <button class="button is-rounded" onclick="{refreshAnswersClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> <span>Refresh!</span> </button> </div> </article> <article class="message is-warning is-large" if="{!questions.length && !questionsLoading}"> <div class="message-body"> There are no questions for this lesson yet! </div> </article> <article class="message" if="{!questionsLoading && questions.length > 0}"> <div class="message-header"> <p>Knowledge Check</p> <span class="tag is-light">{getAnsweredCount()} / {questions.length} answered</span> </div> <div class="message-body" if="{answersLoading}"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="message-body" if="{!answersLoading}"> <div class="box" each="{q,i in questions}"> <h6 class="title is-6" style="margin-bottom: 0.75rem;">{i + 1}. {q.question}</h6> <textarea if="{q.type===\'fa\'}" class="textarea" id="{selectedActivityRef}_answer_{activeStepIndex}_{getQuestionInputKey(q, i)}" placeholder="Enter your answer here">{getAnswerValue(q)}</textarea> <div class="control" if="{q.type===\'mc\'}"> <label class="radio" each="{o in q.options}" style="display:block; margin-bottom:0.35rem;"> <input type="radio" name="{selectedActivityRef}_answer_{activeStepIndex}_{getQuestionInputKey(q, i)}" riot-value="{o}" checked="{isOptionSelected(q, o)}"> {o} </label> </div> <div class="control" if="{q.type===\'tf\'}"> <label class="radio" style="display:block; margin-bottom:0.35rem;"> <input type="radio" name="{selectedActivityRef}_answer_{activeStepIndex}_{getQuestionInputKey(q, i)}" value="true" checked="{isOptionSelected(q, \'true\')}"> True </label> <label class="radio" style="display:block; margin-bottom:0.35rem;"> <input type="radio" name="{selectedActivityRef}_answer_{activeStepIndex}_{getQuestionInputKey(q, i)}" value="false" checked="{isOptionSelected(q, \'false\')}"> False </label> </div> <p class="is-size-7 has-text-grey" if="{getAnswerValue(q)}">Saved answer loaded</p> <p class="is-size-7 has-text-grey" if="{!getAnswerValue(q)}">No answer yet</p> </div> <div class="buttons" style="margin-top: 25px;"> <button class="button is-success" onclick="{saveAllAnswersClick}" disabled="{submitQuizLoading}"> <span class="icon is-small"> <i class="fas fa-save"></i> </span> <span>Save All Answers</span> </button> <button class="button" disabled if="{showQuestionSaveConfirmation}"> <span class="icon is-small"> <i class="fas fa-check"></i> </span> <span>All Answers Saved!</span> </button> <button class="button is-success is-loading" disabled if="{submitQuizLoading}"> Saving... </button> </div> </div> </article>', '', '', function(opts) {

        console.log('knowledge-check.tag.riot SCRIPT LOADED');

        var self = this;

        self.answersLoading = false;
        self.submitQuizLoading = false;
        self.questionsLoading = true;
        self.allQuestions = [];
        self.questions = [];
        self.answers = [];
        self.showQuestionSaveConfirmation = false;

        self.activeStep = self.opts.activestep;
        self.activeStepIndex = self.opts.activestepindex;
        self.selectedActivityRef = (self.opts.selectedActivity && self.opts.selectedActivity.activity_ref)
            || (self.opts.selectedactivity && self.opts.selectedactivity.activity_ref)
            || self.opts.selectedActivityRef
            || null;

        self.on('mount', function() {
            console.log("mounted knowledge-check.tag");
            console.log("opts:", self.opts);
            console.log("activeStep:", self.opts.activeStep);
            console.log("selectedActivityRef:", self.opts.selectedActivityRef);

            var lessonId = self.getLessonId();
            if (lessonId) {
                console.log('Fetching questions from API for lesson:', lessonId);
                getQuestions(lessonId);
            } else {
                self.questionsLoading = false;
                self.questions = [];
                self.update();
                console.log('No lesson found to fetch questions');
            }
        });

        events.on('get_quiz_responses', function(data) {
            self.activeStep = data['activeStep'];
            self.selectedActivityRef = data['act_ref'];
            self.activeStepIndex = data['activeStepIndex'];
            console.log('Received get_quiz_responses event:', data);

            self.questions = filterQuestionsForActiveStep(self.allQuestions);
            self.update();

            if (self.questions.length > 0) {
                getAnswers(self.selectedActivityRef);
            }
        });

        events.on('questions_loaded', function(data) {
            if (self.questions.length > 0) {
                getAnswers(self.selectedActivityRef);
            }
        });

        this.refreshAnswersClick = function(e) {
            getAnswers(self.selectedActivityRef);
        }.bind(this)

        this.getLessonId = function() {
            if (self.opts.selectedActivity && self.opts.selectedActivity.lesson && self.opts.selectedActivity.lesson.id) {
                return self.opts.selectedActivity.lesson.id;
            }
            if (self.opts.selectedactivity && self.opts.selectedactivity.lesson && self.opts.selectedactivity.lesson.id) {
                return self.opts.selectedactivity.lesson.id;
            }
            if (self.parent && self.parent.selectedActivity && self.parent.selectedActivity.lesson && self.parent.selectedActivity.lesson.id) {
                return self.parent.selectedActivity.lesson.id;
            }
            return undefined;
        }.bind(this)

        this.getQuestionId = function(question) {
            if (!question) {
                return undefined;
            }
            return question.id || question.question_id || question.questionId || question._id;
        }.bind(this)

        this.getQuestionStepIndex = function(question) {
            if (!question) {
                return undefined;
            }

            var candidate = question.activity_step;
            if (candidate === undefined || candidate === null) candidate = question.step;
            if (candidate === undefined || candidate === null) candidate = question.step_index;
            if (candidate === undefined || candidate === null) candidate = question.lesson_step;
            if (candidate === undefined || candidate === null) return undefined;

            var parsed = parseInt(candidate, 10);
            return isNaN(parsed) ? undefined : parsed;
        }.bind(this)

        this.getQuestionInputKey = function(question, index) {
            var qid = this.getQuestionId(question);
            if (qid !== undefined && qid !== null && String(qid).trim() !== '') {
                return String(qid);
            }
            return 'idx_' + index;
        }.bind(this)

        this.getAnswerByQuestionId = function(questionId) {
            if (!self.answers || self.answers.length === 0) {
                return undefined;
            }

            var normalizedQuestionId = String(questionId);
            for (var i = 0; i < self.answers.length; i++) {
                var answerQid = self.answers[i].question_id || self.answers[i].questionId || self.answers[i].id;
                if (String(answerQid) === normalizedQuestionId) {
                    return self.answers[i];
                }
            }

            return undefined;
        }.bind(this)

        this.getAnswerValue = function(question) {
            var questionId = this.getQuestionId(question);
            if (questionId === undefined || questionId === null) {
                return '';
            }
            var answerObj = this.getAnswerByQuestionId(questionId);
            if (!answerObj || answerObj.answer === undefined || answerObj.answer === null) {
                return '';
            }
            return String(answerObj.answer);
        }.bind(this)

        this.isOptionSelected = function(question, optionValue) {
            return this.getAnswerValue(question) === String(optionValue);
        }.bind(this)

        this.getAnsweredCount = function() {
            if (!self.questions || self.questions.length === 0) {
                return 0;
            }

            var count = 0;
            for (var i = 0; i < self.questions.length; i++) {
                var answerValue = this.getAnswerValue(self.questions[i]);
                if (answerValue && answerValue.trim() !== '') {
                    count += 1;
                }
            }
            return count;
        }.bind(this)

        this.getInputAnswerValue = function(question, index) {
            var inputId = self.selectedActivityRef + "_answer_" + self.activeStepIndex + "_" + this.getQuestionInputKey(question, index);

            if (question.type === 'fa') {
                var textElement = document.getElementById(inputId);
                return textElement ? textElement.value.trim() : '';
            }

            if (question.type === 'mc' || question.type === 'tf') {
                var options = document.getElementsByName(inputId);
                for (var i = 0; i < options.length; i++) {
                    if (options[i].checked) {
                        return options[i].value;
                    }
                }
            }

            return '';
        }.bind(this)

        this.saveAllAnswersClick = function() {
            if (!self.selectedActivityRef) {
                self.answersError = 'Missing activity reference. Please refresh and try again.';
                self.showQuestionSaveConfirmation = false;
                self.update();
                return;
            }

            var payloads = [];
            var skippedQuestions = 0;
            var lessonId = self.getLessonId();

            for (var i = 0; i < self.questions.length; i++) {
                var question = self.questions[i];
                var answerValue = this.getInputAnswerValue(question, i);
                if (!answerValue) {
                    continue;
                }

                var questionId = this.getQuestionId(question);
                if (questionId === undefined || questionId === null || String(questionId).trim() === '') {
                    skippedQuestions += 1;
                    continue;
                }

                payloads.push({
                    activity_ref: self.selectedActivityRef,
                    question_id: questionId,
                    lesson_id: lessonId,
                    answer: answerValue
                });
            }

            if (payloads.length === 0) {
                self.answersError = skippedQuestions > 0
                    ? 'Some questions are missing IDs and could not be saved.'
                    : undefined;
                self.showQuestionSaveConfirmation = false;
                self.update();
                return;
            }

            self.submitQuizLoading = true;
            self.showQuestionSaveConfirmation = false;
            self.answersError = undefined;
            self.update();

            var completed = 0;
            var hadError = false;

            for (var p = 0; p < payloads.length; p++) {
                postAnswers(payloads[p]).then(function() {
                    completed += 1;
                    if (completed === payloads.length) {
                        self.submitQuizLoading = false;
                        self.showQuestionSaveConfirmation = !hadError;
                        if (skippedQuestions > 0) {
                            self.answersError = 'Saved answers, but ' + skippedQuestions + ' question(s) were skipped because IDs were missing.';
                        }
                        self.update();
                        getAnswers(self.selectedActivityRef);
                    }
                }).catch(function() {
                    hadError = true;
                    completed += 1;
                    if (completed === payloads.length) {
                        self.submitQuizLoading = false;
                        self.showQuestionSaveConfirmation = false;
                        self.answersError = 'Unable to save one or more answers. Please try again.';
                        self.update();
                        getAnswers(self.selectedActivityRef);
                    }
                });
            }
        }.bind(this)

        function getQuestions(lesson_id) {
            self.questionsLoading = true;
            self.update();

            libGetQuestions(lesson_id).then(function(res) {
                var fetchedQuestions = res['data']['questions'] || [];
                self.questionsLoading = false;
                self.allQuestions = fetchedQuestions;
                self.update({
                    questions: filterQuestionsForActiveStep(fetchedQuestions),
                });
                events.emit('questions_loaded', self.questions);
            }).catch(function(error) {
                console.error('GET Questions Error:' + error);
                self.questionsLoading = false;
                self.update({
                    allQuestions: [],
                    questions: [],
                    questionsError: error
                });
            });
        }

        function filterQuestionsForActiveStep(questionList) {
            if (!questionList || questionList.length === 0) {
                return [];
            }

            var hasStepMetadata = false;
            for (var i = 0; i < questionList.length; i++) {
                if (self.getQuestionStepIndex(questionList[i]) !== undefined) {
                    hasStepMetadata = true;
                    break;
                }
            }

            if (!hasStepMetadata) {
                return questionList;
            }

            var filtered = [];
            for (var j = 0; j < questionList.length; j++) {
                if (self.getQuestionStepIndex(questionList[j]) === self.activeStepIndex) {
                    filtered.push(questionList[j]);
                }
            }

            return filtered;
        }

        function getAnswers(act_ref, question_id) {
            self.answersLoading = true;
            self.update();

            var user_profile = localStorage.getItem('profile');
            var userId = JSON.parse(user_profile).user_id;

            libGetAnswers(act_ref, userId, question_id).then(function(res) {
                self.answersLoading = false;
                self.answers = res['data']['answers'] || [];
                self.update();
            }).catch(function(error) {
                console.error('GET Answers Error:' + error);
                self.update({
                    answers: [],
                    answersError: error
                });
            });
        }

        function postAnswers(data) {
            var ansData = {
                "answer": data
            }
            console.log('POST Answers:', ansData);

            return libPostAnswers(data).then(function(res) {
                self.update({
                    postedAnswers: res && res['data'] ? res['data']['answers'] : [],
                    answersError: undefined
                });
                return res;

            }).catch(function(error) {
                console.error('POST Answers Error:' + error);
                self.update({
                    answersError: error
                });
                throw error;
            });
        }
});
